export default "/directory/static/performs_same_sex.d42e45de.svg";